import { useCallback } from 'react';
import { prop } from 'ramda';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { useUserSelector } from '@core/js/store/hooks';

import { useDynamicTagList } from '@interlayer/js/app/hooks/useDynamicTagList';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

const checkValue = (array: (string | undefined)[], value = '') => {
    return array
        .some((string: string | undefined) => string && value && value.toLowerCase().includes(string?.toLowerCase()));
};

export const useCheckPassword = (t: ITranslateMethod) => {
    const {
        email,
        lastName,
        firstName
    } = useUserSelector(prop('userDetails')) || {};
    const passwordBlockedWords = useDynamicTagList({
        tagName: DYNAMIC_TAG_NAMES.passwordBlockedWords,
        defaultValue: 'password, buzzbingo'
    });

    return useCallback((value = '', _: unknown, values: { [key: string]: string }) => {
        const checkObj = {
            email: [values?.email, email],
            firstname: [values?.firstname, firstName],
            lastname: [values?.lastname, lastName]
        };
        const errorKey = Object.keys(checkObj).find((key) => checkValue(checkObj[key as keyof typeof checkObj], value));

        if (errorKey) {
            return [t(`password.blocked.${errorKey}`)];
        }

        const blockedWord = passwordBlockedWords
            .find((word: string) => value.toLowerCase().includes(word.toLowerCase()));

        if (blockedWord) {
            return [t(`password.blocked.${blockedWord}`, 'password.blocked.word')];
        }
    }, [email, firstName, lastName, passwordBlockedWords, t]);
};
